<!-- explain - detailed [ 说明 - 明细 ] -->
<template>

    <div id='explainDetailed'>
        <!-- title -->
        <h1>补交阶梯差价计算说明</h1>

        <!-- table -->
        <div class="table">
            <el-table ref="filterTable" :data="tableData" style="width: 1200px;margin: auto;">
                <el-table-column prop="grade" label="年阶梯分档"></el-table-column>
                <el-table-column prop="range" label="电量"></el-table-column>
                <el-table-column prop="price" label="电价（元 / 度）">
                <template scope="scope">
                    <el-tag :type="scope.row.type === 0 ? 'success' : scope.row.type === 1 ? 'warning' : 'danger'" disable-transitions>￥ {{scope.row.price}}</el-tag>
                </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- content -->
        <div class="content">
            <el-alert title="" type="info" style="margin-bottom: 20px;" description="电表设置电价说明：本年阶梯电表设置电价为无阶梯0.52元/度，电表本身计量一直按照0.52元/度计算，如果用量超出阶梯范围，则进行补交差价，补交差价在充值时自动扣除。" show-icon :closable="false"></el-alert>

            <el-collapse v-model="activeNames">

                <el-collapse-item title="本次补交阶梯差价计算明细：" name="1">
                    <p>充值前本年用量：<span class="val">{{diffLoad.yeartotal}}</span> 度</p>
                    <p>超过标准用量：<span class="val">{{diffLoad.exceed}}</span> 度 <small class="red" v-if="newyear != 0">（注：上次缴费日期截止到当前超出的标准用量）</small></p>
                    <p>第二阶梯差价单价：0.05 元 / 度</p>
                    <p>第三阶梯差价单价：0.3 元 / 度</p>
                    <p>第二阶梯差价：{{diffLoad.first}} 度 * 0.05 = {{diffLoad.firstDiff}} 元</p>
                    <p>第三阶梯差价：{{diffLoad.two}} 度 * 0.3元 = {{diffLoad.twoDiff}} 元</p>
                    <p>补交阶梯差价：第一阶梯差价 + 第二阶梯差价 = {{diffLoad.diff}} 元</p>
                </el-collapse-item>

            </el-collapse>
        </div>
    </div>

</template>

<script>
export default {
    components: { },

    props: [],

    data() {
        return{
            tableData: [
                {
                    grade: '第 1 阶梯',
                    range: '0 ~ 2160度',
                    price: '0.52',
                    type: 0
                },
                {
                    grade: '第 2 阶梯',
                    range: '2160 ~ 3360度',
                    price: '0.57',
                    type: 1
                },
                {
                    grade: '第 3 阶梯',
                    range: '3360度以上',
                    price: '0.82',
                    type: 2
                },
            ],

            activeNames: ['1'],

            // query
            yeartotalKey: null,
            newyear: null,
            diffLoad: {
                yeartotal: '',
                exceed: '',
                first: '',
                firstDiff: '',
                two: '',
                twoDiff: '',
                diff: '',
            },
        }
    },

    computed: { },

    watch: {
        route: {
            handler: function(val, old){

            },
            deep: true
        }
    },

    created(){

    },

    mounted(){
        this.loadMain();

        this.getData();
    },

    methods:{
        loadMain(){
            this.yeartotalKey = this.$route.query.yeartotal;
            this.newyear = this.$route.query.newyear;
            this.diffLoad = JSON.parse(localStorage['ladder']);
        },

        getData(){

        },

        // 分 => 元
        yuan(num){
            num = num.toFixed(2);
            return num;
        },
    },
}
</script>

<style scoped>
    body, html{
        margin: 0;
        padding: 0;
    }

    h1{
        padding: 30px 0;
        text-align: center;
        font-weight: 500;
    }

    .content{
        margin: auto;
        padding: 20px 0;
        width: 1200px;
    }

    small.red{
        color: red;
    }
</style>

<style>
    .el-table .cell{
        text-align: center;
    }

    .el-alert--info{
        background-color: #f4f3f5 !important;
    }

    .el-alert--info .el-alert__icon{
        color: #909399;
    }

    .el-alert .el-alert__description{
        color: #909399 !important;
    }
</style>


// WEBPACK FOOTER //
// explainDetailed.vue?ed1fdd32